import { AmbitoDTO } from '@framework/api-client';
import { TreeSelectInput } from '@framework/ui';
import React from 'react';
import { useScopesData } from '../useScopesData';

export interface ICommonScopeTreeSelectInputProps {
  data?: AmbitoDTO[] | null;
  isLoading: boolean;
  name: string;
  placeholder?: string;
}

/**
 * Input per la selezione di un ambito.
 */
export function CommonScopeTreeSelectInput(
  props: ICommonScopeTreeSelectInputProps,
) {
  const { data, isLoading, name, placeholder } = props;

  const treeDataScopes = useScopesData(data);

  return (
    <TreeSelectInput
      treeData={treeDataScopes}
      name={name}
      loading={isLoading}
      style={{ width: '100%' }}
      dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
      treeDefaultExpandAll
      placeholder={placeholder}
    />
  );
}
